import gql from "graphql-tag";

const projectContactNoteMutations = {


    createProjectContactNote: gql`
        mutation CreateProjectContactNote($project_id: Int, $contact_id: Int, $user_id: Int, $note_id: Int, $note_content: String, $title: String, $communication_name: String, $communication_ident: String, $reminder: DateTime) {
            createProjectContactNote(project_id: $project_id, contact_id: $contact_id, user_id: $user_id, note_id: $note_id, note_content: $note_content, title: $title, communication_name: $communication_name, communication_ident: $communication_ident, reminder: $reminder) {
                id,
                project_id,
                contact_id,
                user_id,
                note_id,
                note_content,
                title,
                communication_name,
                communication_ident,
                reminder
            }
        }
    `,
    updateProjectContactNote: gql`
        mutation UpdateProjectContactNote($id: ID!, $project_id: Int, $contact_id: Int, $user_id: Int, $note_id: Int, $note_content: String, $title: String, $communication_name: String, $communication_ident: String, $reminder: DateTime) {
            updateProjectContactNote(id: $id, project_id: $project_id, contact_id: $contact_id, user_id: $user_id, note_id: $note_id, note_content: $note_content, title: $title, communication_name: $communication_name, communication_ident: $communication_ident, reminder: $reminder) {
                id,
                project_id,
                contact_id,
                user_id,
                note_id,
                note_content,
                title,
                communication_name,
                communication_ident,
                reminder
            }
        }
    `,
};

export default projectContactNoteMutations;